
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    EDIT_SWAP_SIM_CARD_GET_DEVICE_REQUEST,
    EDIT_SWAP_SIM_CARD_GET_SIM_DETAILS_REQUEST,
    EDIT_SWAP_SIM_CARD_UPDATE_UNIT_SIM_CARD_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { editSwapSimCardGetDeviceResult, editSwapSimCardGetSimDetailsResult, editSwapSimCardUpdateResult } from 'Redux/actions';


function* getUnit({ payload }) {
    try {
        const QUERY = `
            query getUnit ($id: Int!) {
                result: getUnit (id: $id) {
                    id
                    label
                    esn
                    imei
                    simCard {
                        iccId
                        msisdn
                        simProviderAccount {
                            id
                            name
                            simProviderId
                            simProvider {
                                id
                                name
                            }
                        }
                    }
                    deviceModel {
                        id
                        name
                        manufacturerId
                        manufacturer {
                            id
                            name
                        }
                    }
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );
        if (data?.result) {
            yield put(editSwapSimCardGetDeviceResult(data?.result))
        }

    } catch (exc) {
        yield put(editSwapSimCardGetDeviceResult({ error }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/editSwapSimCard/redux/saga",
            "getUnit",
        )
    }
}

function* getSimDetails({ payload }) {
    try {
        let QUERY = `
            query getSimDetails ($iccid: String!) {
                result: getSimDetails (iccid: $iccid)
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                iccid: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(editSwapSimCardGetSimDetailsResult({ result: data?.result }))

    } catch (exc) {
        yield put(editSwapSimCardGetSimDetailsResult({ result: null, error: exc }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/editSwapSimCard/redux/saga",
            "getSimDetails",
        )
    }
}

function* updateUnitSimCard({ payload }) {
    try {
        let QUERY = `
            mutation updateUnitSimCard ($id: Int!, $simProviderAccountId: Int, $iccid: String, $msisdn: String) {
                result: updateUnitSimCard (id: $id, simProviderAccountId: $simProviderAccountId, iccid: $iccid, msisdn: $msisdn)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(editSwapSimCardUpdateResult({ update: data.result }))

    } catch (exc) {
        yield put(editSwapSimCardUpdateResult({ update: false, error: exc }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/editSwapSimCard/redux/saga",
            "updateUnitSimCard",
        )
    }
}

function* watchMethods() {
    yield takeEvery(EDIT_SWAP_SIM_CARD_GET_DEVICE_REQUEST, getUnit);
    yield takeEvery(EDIT_SWAP_SIM_CARD_GET_SIM_DETAILS_REQUEST, getSimDetails);
    yield takeEvery(EDIT_SWAP_SIM_CARD_UPDATE_UNIT_SIM_CARD_REQUEST, updateUnitSimCard);
}



export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}